import { Skeleton } from "components/DesignSystem/Skeleton/Skeleton";
import Table from "components/DesignSystem/Table/V2/Table";
import React from "react";
import { Table as TableProps } from "react-table-8.10.7";

export const TableUiBodyLoader = <T,>({
  table,
  sizeType,
}: {
  table: TableProps<T>;
  sizeType?: "percent" | "absolute";
}) => {
  return (
    <Table.Body className="t-space-y-3 t-mt-3 t-h-full t-w-full">
      {Array.from({ length: 4 }, (_, index) => (
        <Table.Row key={index}>
          {table.getAllLeafColumns().map((column) => (
            <Table.Cell
              key={column.id}
              style={{
                width:
                  sizeType === "percent"
                    ? `${column.getSize()}%`
                    : `${column.getSize()}px`,

                minWidth:
                  sizeType === "absolute" ? `${column.getSize()}px` : "auto",
              }}
            >
              <Skeleton className="t-h-10 t-w-full" />
            </Table.Cell>
          ))}
        </Table.Row>
      ))}
    </Table.Body>
  );
};
